import { gql } from '@apollo/client'

export const Query = gql`
  query EditEventItem($companyId: ID!, $eventId: ID!, $eventItemId: ID!) {
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventItems(filters: { idEq: $eventItemId }, first: 1) {
          nodes {
            id
            eventStage { id }
            notes
            quantity
            discount
            item {
              ...on AssetType {
                id
                name
                images { id url }
              }
              ...on Package {
                id
                name
                images { id url }
              }
              ...on RowItem {
                id
                name
                images { id url }
              }
              ...on Vehicle {
                id
                name
                images { id url }
              }
            }
          }
        }
      }
    }
  }
`
